import "@/utils/modernizer/webp.js";

// Polyfill for intersectionObserver
import "intersection-observer";

// Polyfill for scrollIntoView object parameter (safari has no support for it at all)
import smoothscroll from "smoothscroll-polyfill";
// kick off the polyfill!
smoothscroll.polyfill();

import "url-search-params-polyfill";
